
<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="currentColor"
  width="24"
  height="24"
  viewBox="0 0 24 24"><defs><clipPath id="b"><rect width="24" height="24"/></clipPath></defs><g id="a" clip-path="url(#b)"><path d="M128.027,43.02c0,5.784,0,10.516.005,10.516l2.278-.436,2.273-.436.005-3.9.005-3.895h2.883l.012-.62c.007-.341.017-1.308.024-2.15l.012-1.531h-2.93V37.057l.049-.053c.071-.076.038-.075,1.828-.081.9,0,1.646-.01,1.652-.016s.4-4.265.4-4.357V32.5h-8.5V43.02" transform="translate(-120.276 -31.02)" fill-rule="evenodd"/></g></svg>
